import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from "i18next-browser-languagedetector";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //   .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "es",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          // here we will place our translations...
          "Find Your Match Before the Music Stops!":
            "Find Your Match Before the Music Stops!",
          "Discover sparks in real time with people at the same event. No swipes, just connections.":
            "Discover sparks in real time with people at the same event. No swipes, just connections.",
          Features: "Features",
          "Key Features": "Key Features",
          "How It Works": "How it works",
          "Try It Now!": "Try It Now!",
          "Find Players": "Find Players",
          "Connect with basketball enthusiasts in your area.":
            "Connect with basketball enthusiasts in your area.",
          "Locate Courts": "Locate Courts",
          "Discover nearby basketball courts for your games.":
            "Discover nearby basketball courts for your games.",
          "Schedule Games": "Schedule Games",
          "Easily organize and join basketball games.":
            "Easily organize and join basketball games.",
          "Create Your Profile": "Create Your Profile",
          "Sign up and set your preferences for playing basketball.":
            "Sign up and set your preferences for playing basketball.",
          "Find or Create a Game": "Find or Create a Game",
          "Browse available games or start your own match.":
            "Browse available games or start your own match.",
          "Play and Connect": "Play and Connect",
          "Meet up, play basketball, and make new friends!":
            "Meet up, play basketball, and make new friends!",
          "Try PartyFlirt Today": "Try PartyFlirt Today",
          "Get ready to revolutionize your basketball experience. Download the app now!":
            "Get ready to revolutionize your basketball experience. Download the app now!",
          "Get Started": "Get Started",
          "Learn More": "Learn More",
        },
      },
      es: {
        translation: {
          // here we will place our translations...
          "Find Your Match Before the Music Stops!":
            "Encuentra tu match antes de que la música se detenga!",
          "Discover sparks in real time with people at the same event. No swipes, just connections.":
            "Descubre conexiones en tiempo real con personas en el mismo evento. Sin esperas, conecta ahora!",
          Features: "Funciones",
          "Key Features": "Funciones principales",
          "How It Works": "¿Cómo funciona?",
          "Try It Now!": "¡Pruébala Ahora!",
          "Find Players": "Encuentra jugadores",
          "Connect with basketball enthusiasts in your area.":
            "Conecta con amantes del baloncesto en tu ciudad.",
          "Locate Courts": "Encuentra Pistas",
          "Discover nearby basketball courts for your games.":
            "Descubre pistas de baloncesto cercanas para jugar.",
          "Schedule Games": "Organiza Partidos",
          "Easily organize and join basketball games.":
            "Organiza o únete a partidas de baloncesto.",
          "Create Your Profile": "Crea tu Perfil",
          "Sign up and set your preferences for playing basketball.":
            "Regístrate y configura tus preferencias para jugar baloncesto.",
          "Find or Create a Game": "Encuentra o Crea una Partida",
          "Browse available games or start your own match.":
            "Busca partidas disponibles o crea la tuya.",
          "Play and Connect": "Juega y Conecta",
          "Meet up, play basketball, and make new friends!":
            "Juega baloncesto y has nuevos amigos!",
          "Try PartyFlirt Today": "Prueba PartyFlirt Hoy Mismo",
          "Get ready to revolutionize your basketball experience. Download the app now!":
            "Estás listo para revolucionar tu experiencia de baloncesto. ¡Descarga la aplicación ahora!",
          "Get Started": "Empezar",
          "Learn More": "Descubre más",
        },
      },
    },
  });

export default i18n;
